// extracted by mini-css-extract-plugin
export default {"hidden":"SheetTitle__hidden--JuTdv","sectionTitle":"SheetTitle__sectionTitle--GqoHP","sectionHeader":"SheetTitle__sectionHeader--f3BFq"};